'use client'

import Link from 'next/link'
import { Button } from '@/components/ui/button'
import { SectionHeader } from '@/components/section-header'
import { S3Image } from '@/components/S3Image'

export function TrustSection() {
  // ✅ Un único "ancla" de alineación para TODO el bloque izquierdo
  const align = 'pl-4 md:pl-6 lg:pl-[140px]'

  return (
    <section className='w-full bg-white py-24 px-4 md:px-8'>
      <div className='max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center'>
        {/* TEXTO */}
        <div className='order-2 lg:order-1 lg:col-span-6'>
          <SectionHeader
            title='Calidad real, pensada para durar'
            subtitle='Materiales hechos para acompañar cada etapa de la infancia.'
            className={`mb-6 ${align}`}
          />

          {/* Texto + items + CTA alineados al SectionHeader */}
          <div className={`${align}`}>
            <div className='font-sans text-body text-[#736A47] space-y-4 max-w-[720px]'>
              <p>
                No todos los materiales Montessori son iguales. En Kuma
                seleccionamos materiales fabricados con estándares
                internacionales, diseño intencional y terminaciones de calidad
                para acompañar todas las etapas de los 0 a 12 años.
              </p>

              <p>
                Conocé nuestra colección de{' '}
                <Link
                  href='/juguetes-de-madera'
                  className='underline underline-offset-4 hover:text-[#8a7e55] transition-colors'
                >
                  juguetes de madera Montessori certificados
                </Link>{' '}
                fabricados en madera de haya grado AAA, con pinturas al agua no
                tóxicas y estándares internacionales de seguridad.
              </p>
            </div>

            <ul className='mt-6 space-y-2 text-sm text-[#7D744F] max-w-[720px]'>
              <li>
                • Utilizamos maderas seleccionadas como madera de haya grado AAA
              </li>
              <li>• Bordes suaves y encastres precisos</li>
              <li>• Acabados y pinturas al agua, no tóxicos</li>
              <li>• Certificado de Safe Child internacionales</li>
              <li>• Especialistas en Montessori, de 0 a 12 años</li>
            </ul>

            <div className='mt-8'>
              <Link href='/productos'>
                <Button variant='primary' size='lg' className='px-8 py-4'>
                  Explorar materiales
                </Button>
              </Link>

              <div className='mt-4'>
                <Link
                  href='/juguetes-de-madera'
                  className='text-sm text-[#7D744F] underline underline-offset-4 hover:text-[#8a7e55] transition-colors'
                >
                  Ver colección completa de juguetes de madera →
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* IMAGEN */}
        <div className='order-1 lg:order-2 lg:col-span-6 lg:-ml-2'>
          {/* ✅ Ancho limitado para que termine donde marcaste */}
          <div className='relative w-full max-w-[560px] h-[400px] sm:h-[540px] lg:h-[660px] overflow-hidden bg-[#F4F6EF]'>
            <S3Image
              src='/images/manosbebe.webp'
              alt='Bebé manipulando material Montessori de madera'
              width={1200}
              height={900}
              className='w-full h-full object-cover'
            />
          </div>
        </div>
      </div>
    </section>
  )
}
